// extracted by mini-css-extract-plugin
export default {"container":"MissionAssignNinjas_container__dpuxk","crowdsourceLabel":"MissionAssignNinjas_crowdsourceLabel__UZrJN","crowdsourceIcon":"MissionAssignNinjas_crowdsourceIcon__2l9Ay"};